import React, { useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { Grid } from '@material-ui/core'
import { getLinks } from '../../store/actions/links/links'
import { useToken } from './../../hooks/useToken'
import { Loader } from '../Loader/Loader'
import { LinksList } from './LinksList/LinksList'
export const LinksPage = () => {
  const dispatch = useDispatch()
  const headers = useToken()
  const isLoading = useSelector((state) => state.loader.isLoading)
  const isReady = useSelector((state) => state.links.isReady)

  useEffect(() => {
    dispatch(getLinks(headers))
  }, [dispatch]) //eslint-disable-line

  if (isLoading && !isReady) {
    return <Loader />
  }
  return (
    <Grid item xs={12}>
      {isReady && <LinksList />}
    </Grid>
  )
}
